// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  if (chunkId === 828) return "static/css/828.bb01b5be.css";
  // return url for filenames based on template
  return "" + chunkId + ".css"
}